import { createContext, useState, useContext } from "react"

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
    const [loginUser, setLoginUser] = useState(null)
    const [role, setRole] = useState(null)

    return (
        <AuthContext.Provider value={{ loginUser, setLoginUser, role, setRole }}>
            {children}
        </AuthContext.Provider>
    )
}
export const useAuth = () => useContext(AuthContext)
